const runtimeConfig = globalThis.__PORTAL__?.config ?? {};

const getConfigValue = (key, legacyKey = null) => {
  const envValue = process.env[key];
  if (envValue !== undefined && envValue !== "") {
    return envValue;
  }

  if (legacyKey) {
    const legacyEnvValue = process.env[legacyKey];
    if (legacyEnvValue !== undefined && legacyEnvValue !== "") {
      return legacyEnvValue;
    }
  }

  if (runtimeConfig[key]) {
    return runtimeConfig[key];
  }

  if (legacyKey && runtimeConfig[legacyKey]) {
    return runtimeConfig[legacyKey];
  }

  return "";
};

export const apiManagement = getConfigValue("REACT_APP_API_MANAGEMENT");
export const ocpApimSubscriptionKey = getConfigValue("REACT_APP_OCP_APIM_SUBSCRIPTION_KEY");
export const googleApiKey = getConfigValue("REACT_APP_GOOGLE_API_KEY");
export const leadMarketAffiliateCode = getConfigValue("REACT_APP_LEAD_MARKET_AFFILIATE_CODE");
export const leadMarketMode = getConfigValue("REACT_APP_LEAD_MARKET_MODE");
export const runConfiguration = getConfigValue("REACT_APP_ENVIRONMENT_RUN_CONFIGURATION");
export const bankStatementIframeUrl = getConfigValue("REACT_APP_BS_IFRAME_URL");
export const portalDebug = getConfigValue("REACT_APP_PORTAL_DEBUG");
export const authUrl = getConfigValue("REACT_APP_AUTH_URL");
export const appUrl = getConfigValue("REACT_APP_URL");
export const authClientId = getConfigValue("REACT_APP_CLIENT_ID");
export const publicWebsite = getConfigValue("REACT_APP_PUBLIC_WEBSITE");
export const newCustomerForm = getConfigValue("REACT_APP_NEW_CUSTOMER_FORM");
export const privacyPolicy = getConfigValue("REACT_APP_FGF_PRIVACY_POLICY", "FGF_PRIVACY_POLICY");
export const termsConditions = getConfigValue("REACT_APP_FGF_TERMS_AND_CONDITIONS", "FGF_TERMS_AND_CONDITIONS");
export const referralForm = getConfigValue("REACT_APP_REFERRAL");
export const contentManagementUrl = getConfigValue("REACT_APP_CONTENT_URL");
export const contentToken = getConfigValue("REACT_APP_CONTENT_TOKEN");
export const gtmId = getConfigValue("REACT_APP_GTM_ID", "GTM_ID");
export const gtmAuth = getConfigValue("REACT_APP_GTM_AUTH", "GTM_AUTH");
export const gtmPreview = getConfigValue("REACT_APP_GTM_PREVIEW", "GTM_PREVIEW");
export const magicBlocksWorkspaceId = getConfigValue("REACT_APP_MAGICBLOCKS_WORKSPACE_ID");
export const magicBlocksExperienceId = getConfigValue("REACT_APP_MAGICBLOCKS_EXPERIENCE_ID");
export const magicBlocksTestModeToggle = getConfigValue("REACT_APP_MAGICBLOCKS_TEST_MODE");
